export default __webpack_public_path__ + "static/media/gable.ba4c4c28.png";